export enum LoginSource {
  APP = 'APP',
  WEB = 'WEB',
}
